import React from 'react';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { SortingIcon } from '@atlaskit/editor-common/table';
export var SortingIconWrapper = function SortingIconWrapper(props) {
  var _useSharedPluginState = useSharedPluginStateWithSelector(props.api, ['editorViewMode'], function (states) {
      var _states$editorViewMod;
      return {
        mode: (_states$editorViewMod = states.editorViewModeState) === null || _states$editorViewMod === void 0 ? void 0 : _states$editorViewMod.mode
      };
    }),
    mode = _useSharedPluginState.mode;
  if (mode === 'edit') {
    return null;
  }
  // Ignored via go/ees005
  // eslint-disable-next-line react/jsx-props-no-spreading
  return /*#__PURE__*/React.createElement(SortingIcon, props);
};